import React from "react";
import { cn } from "../../utils/cn";

/**
 * Cabeçalho padrão de card de seção usado nas páginas de Insights
 * (Dashboard, Insights de Posts, Insights de Anúncios).
 *
 * Extraído de uma implementação local idêntica que existia duplicada em
 * Dashboard.tsx, PostsAnalytics.tsx e AdsAnalytics.tsx — consolidado aqui
 * sem nenhuma alteração de classes/estrutura para preservar o visual
 * já aprovado.
 */
interface SectionHeaderProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  iconBgClass?: string;
  action?: React.ReactNode;
  hideBorder?: boolean;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  icon,
  title,
  subtitle,
  iconBgClass = "bg-purple-600",
  action,
  hideBorder = false,
}) => (
  <div
    className={cn(
      "flex items-start gap-3 shrink-0",
      !hideBorder && "border-b pb-2 border-purple-100 mb-3",
    )}
  >
    <div
      className={cn(
        "w-10 h-10 shrink-0 flex items-center justify-center rounded-xl text-white shadow-xs",
        iconBgClass,
      )}
    >
      {icon}
    </div>
    <div className="flex-1 min-w-0 h-10 flex flex-col justify-between">
      <h3 className="text-sm font-bold text-gray-900 uppercase tracking-tight leading-none">
        {title}
      </h3>
      <span className="text-xs text-gray-400 font-medium leading-none">
        {subtitle}
      </span>
    </div>
    {action}
  </div>
);

export default SectionHeader;
